<template>
    <div :class="classNames">
        <div :class="classNames+ '_item'">
            <div :class="classNames+ '_item_vertical'">
                <div :class="classNames+ '_item_icon'">
                    <div :class="classNames+ '_item_icon_bg'" v-if="status === 'success'" >
                        <img src="@/assets/image/success.png" alt="" style="width: 24px;height: 24px"/>
                    </div>
                    <div :class="classNames+ '_item_icon_bg'" v-else-if="status === 'waiting'">
                        <img src="@/assets/image/wait.png" alt=""  style="width: 36px;height: 36px"/>
                    </div>
                     <div :class="classNames+ '_item_icon_bg'" v-else-if="status === 'error'" >
                        <img src="@/assets/image/error.png" alt="" style="width: 24px;height: 24px"/>
                    </div>
                    <div :class="classNames+ '_item_icon_bg'" v-else>
                        <p></p>
                    </div>
                    <div :class="classNames+ '_item_vertical_line'" ref="line"></div>
                </div>
                <div :class="classNames+ '_item_title'">
                    <span v-if="!isHasSlots">{{title}}</span>
                    <slot name="title"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Step',
    props: {
        status: {
            type: String,
            default: 'waiting'
        },
        title: {
            type: String,
            default: 'xxx'
        }
    },
    data() {
        return {
            classNames: 'step_wrap'
        }
    },
   computed: {
       isHasSlots() {
           let flag = this.$scopedSlots?.$hasNormal
           return flag
       }
   }
}
</script>
<style lang="less" scoped>
    @classNames: step_wrap;
    .@{classNames} {
        .@{classNames}_item {
            .@{classNames}_item_vertical {
                display: flex;
            }
            .@{classNames}_item_icon {
               display: flex;
               flex-direction: column;
               align-items: center;
            }
            .@{classNames}_item_icon_bg {
                width: 36px;
                display: flex;
                flex-direction: column;
                align-items: center;
               p{
                    width: 14px;
                    height: 14px;
                    border-radius: 100%;
                    background: #E5E5E5;
               }
            }
            .@{classNames}_item_title {
                margin-left: 52px;
                color: #999999;
                font-size: 16px;
            }
            .@{classNames}_item_vertical_line {
                height: 40px;
                width: 3px;
                background-color: #999999;
            }
        }
    }
</style>